// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oEGE2","top":"styles_top__3C8mn","left":"styles_left__y4Afb","description":"styles_description__1Rso-"};